module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_vm._m(0), _c('section', {
    staticClass: "top_works"
  }, [_c('div', {
    staticClass: "top_works-inner"
  }, [_c('h2', {
    staticClass: "headline"
  }, [_vm._v("Works")]), _c('div', {
    staticClass: "works"
  }, _vm._l((_vm.data), function(d) {
    return _c('div', {
      staticClass: "works_box"
    }, [_c('router-link', {
      staticClass: "common_link-box",
      attrs: {
        "to": '/works/' + d.slug
      }
    }, [_vm._l((d.picture), function(p) {
      return (p.id === '1') ? _c('div', {
        staticClass: "common_thumb effect_img-filter"
      }, [_c('img', {
        attrs: {
          "src": p.path,
          "width": "",
          "height": "",
          "alt": ""
        }
      })]) : _vm._e()
    }), _c('div', {
      staticClass: "works_name"
    }, [_vm._v(_vm._s(d.title))])], 2)], 1)
  }))]), _c('div', {
    staticClass: "common_more"
  }, [_c('router-link', {
    staticClass: "common_more-link",
    attrs: {
      "to": "/works"
    }
  }, [_vm._v("もっと見る")])], 1)]), _c('section', {
    staticClass: "top_about"
  }, [_c('div', {
    staticClass: "section_inner"
  }, [_c('h2', {
    staticClass: "headline"
  }, [_vm._v("About")]), _c('div', {
    staticClass: "top_about-inner"
  }, [_c('div', {
    staticClass: "about_text"
  }, [_vm._m(1), _c('div', {
    staticClass: "about_role"
  }, [_vm._v("Designer / Frontend developer / Illustrator")]), _vm._m(2), _c('div', {
    staticClass: "about_other"
  }, [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("そのほか")])], 1)]), _vm._m(3)])])]), _c('section', {
    staticClass: "top_contact"
  }, [_c('div', {
    staticClass: "section_inner"
  }, [_c('h2', {
    staticClass: "headline"
  }, [_vm._v("Contact")]), _c('div', {
    staticClass: "common_text top_contact-inner"
  }, [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("お問い合わせフォーム")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top_catch"
  }, [_c('div', {
    staticClass: "top_catch-inner"
  }, [_c('div', {
    staticClass: "character"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/txt_top_catch1.png"),
      "src-set": "../assets/img/txt_top_catch1.png, ../assets/img/txt_top_catch1@2x.png 2x, ../assets/img/txt_top_catch1@3x.png 3x",
      "alt": "あたたかくて"
    }
  })]), _c('div', {
    staticClass: "character"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/txt_top_catch2.png"),
      "src-set": "../assets/img/txt_top_catch2.png, ../assets/img/txt_top_catch2@2x.png 2x, ../assets/img/txt_top_catch2@3x.png 3x",
      "alt": "やさしい"
    }
  })]), _c('div', {
    staticClass: "character"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/txt_top_catch3.png"),
      "src-set": "../assets/img/txt_top_catch3.png, ../assets/img/txt_top_catch3@2x.png 2x, ../assets/img/txt_top_catch3@3x.png 3x",
      "alt": "しなやかなコミュニケーションを"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "about_name"
  }, [_vm._v("べこ"), _c('small', {
    staticClass: "about_small"
  }, [_vm._v("beco")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about_sns"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/becolomochi"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  }), _vm._v("Twitter")]), _c('a', {
    attrs: {
      "href": "https://github.com/becolomochi"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  }), _vm._v("GitHub")]), _c('a', {
    attrs: {
      "href": "https://becolomochi.tumblr.com"
    }
  }, [_c('i', {
    staticClass: "fa fa-tumblr"
  }), _vm._v("Tumblr")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about_thumb"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icon1.png"),
      "alt": "icon1"
    }
  }), _c('img', {
    attrs: {
      "src": require("../assets/img/icon2.jpg"),
      "alt": "icon2"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98515234","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top.vue
// module id = 42
// module chunks = 0